module.exports = __webpack_public_path__ + "static/media/phone_iphone-24px.188c375c.svg";